import React from "react";
import { Joyride, STATUS, EventData, Controls, Props as JoyrideProps } from "react-joyride";
import useLocalStorage from "../shared/hooks/useLocalStorage";
import * as _ from "lodash";

export interface RunOnceTourProps extends JoyrideProps {
    id?: string;
}

export default function RunOnceTour(props: RunOnceTourProps) {
    const [hasCompletedTour, setHasCompletedTour] = useLocalStorage(`completed-tour-${props.id || new Date().toISOString()}`, false);

    // This handler just watches for the tour end and records that in local storage.  It wraps over
    // the original handler passed in, adding to its logic...
    const onEventWrapper = (data: EventData, controls: Controls) => {
        const { status } = data;

        // Call the original handler that was passed in...
        props.onEvent && props.onEvent(data, controls);

        // Mark the tour as completed when applicable...
        if (_.includes([STATUS.FINISHED, STATUS.SKIPPED], status)) {
            setHasCompletedTour(true);
        }
    };

    return !hasCompletedTour ?
        <Joyride
            {...props}
            onEvent={onEventWrapper}
        /> :
        null;
}
